<template>
  <div class="workpage" v-if="page == 'works'">
    <Transition>
      <div class="modal" v-if="showVPN">
        <div class="success">
          <img src="@/assets/images/warning.png" alt="" />
          <h1 class="title">WARNING!!!</h1>
          <p>
            If you’re not in China it’s neccessary to install VPN In order to
            access this Site.
          </p>
          <div class="btns-warn">
            <a :href="cur_url" class="btn proc">PROCEED</a>
            <div class="btn return" @click="showVPN = false">RETURN</div>
          </div>
        </div>
      </div>
    </Transition>

    <div class="titles">
      <div class="title">Works</div>
      <p>Projects that I’ve work on</p>
    </div>
    <div class="cards">
      <div
        class="card"
        v-for="(card, index) in cards"
        :key="index"
        :style="{ backgroundImage: 'url' + '(' + card.img + ')' }"
        :class="{ mobilePosition: card.isMobile }"
      >
        <div class="grp-title">
          <div class="title">{{ card.title }}</div>
          <!-- <a :href="card.url" class="btn">VISIT</a> -->
          <a :href="card.url" class="btn" v-if="!card.isVPN">VISIT</a>
          <div
            @click="(showVPN = true), (cur_url = card.url)"
            class="btn"
            v-if="card.isVPN"
          >
            VISIT
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  props: ["page"],
  setup() {
    const cards = ref([
      {
        img: require("@/assets/images/work/918.png"),
        title: "918 Brandsite",
        url: "https://www.918.com/",
        isVPN: false,
      },
      {
        img: require("@/assets/images/work/819.png"),
        title: "918 Botian",
        url: "https://ts611.com/",
        isVPN: true,
      },
      {
        img: require("@/assets/images/work/biyo.png"),
        title: "Bi88 Biyou",
        url: "https://pc.taa8545.com/",
        isVPN: true,
      },
      {
        img: require("@/assets/images/landingpages/5715.png"),
        title: "5715 landing page",
        url: "https://52.229.205.156:9113/amxpjs2?agent=5321606",
        isVPN: false,
      },
      {
        img: require("@/assets/images/landingpages/5715PC.png"),
        title: "5715 PC",
        url: "https://43.198.235.139:9522/pc/",
        isVPN: false,
      },
      {
        img: require("@/assets/images/landingpages/5715h5.png"),
        title: "5715 H5/Mobile",
        url: "https://52.229.212.233:9522/h5/pages/indexLoginBefore/index",
        isVPN: false,
        isMobile: true,
      },
      {
        img: require("@/assets/images/work/w66.png"),
        title: "W66",
        url: "https://w66.com/",
        isVPN: true,
      },
      {
        img: require("@/assets/images/landingpages/landingpage.png"),
        title: "Landing Page Container",
        url: "https://landingpagelist.vercel.app/",
        isVPN: true,
      },
      {
        img: require("@/assets/images/work/skoms.png"),
        title: "SK Management System",
        url: "https://clientsk.legtrack.net/login",
      },
      {
        img: require("@/assets/images/work/watchyo.png"),
        title: "Watchyo",
        url: "https://watchyo.com/",
      },
      {
        img: require("@/assets/images/work/ayr.png"),
        title: "AYR BMS",
        url: "https://development.ddmkou03ig6wl.amplifyapp.com/login",
      },
    ]);
    const showVPN = ref(false);
    const cur_url = ref("");

    return {
      cards,
      cur_url,
      showVPN,
    };
  },
};
</script>

<style lang="scss" scoped>
.workpage {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  .modal {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    .success {
      width: 400px;
      height: 205px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -100%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      border-bottom: 3px solid #f16529;
      color: #04293a;
      .title {
        color: #f16529;
        font-size: 20px;
      }
      p {
        font-size: 15px;
        text-align: center;
      }
      .btns-warn {
        display: flex;
        justify-content: center;
        gap: 30px;
        margin-top: 20px;
        .btn {
          cursor: pointer;
          width: 130px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          font-weight: bolder;
          text-decoration: none;
        }
        .proc {
          border: 2px solid #57bd91;
          color: #04293a;
        }
        .return {
          background: #c44d56;
          border: 2px solid #c44d56;
          color: #fff;
        }
      }
    }
  }

  .titles {
    text-align: center;
    margin: 20px 0 50px;
    .title {
      font-size: 50px;
      color: #ecb365;
      font-weight: 700;
    }
    p {
      color: #fff;
      font-size: 20px;
      font-weight: lighter;
    }
  }
  .cards {
    display: flex;
    gap: 50px;
    flex-wrap: wrap;
    width: 95vw;
    justify-content: center;
    .card {
      width: 280px;
      height: 280px;
      background: #041c32;
      box-shadow: 0 0 30px #000;
      border-radius: 15px;
      background-size: cover;
      background-position-y: -90px;
      background-position-x: -90px;
      background-repeat: no-repeat;
      position: relative;
      .grp-title {
        position: absolute;
        bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 7px;
        .title {
          color: #ecb365;
          font-size: 20px;
        }
        .btn {
          color: #ecb365;
          border: 2px solid #ecb365;
          padding: 3px 30px;
          border-radius: 20px;
          text-decoration: none;
          cursor: pointer;
        }
      }
    }
  }
}

.mobilePosition {
  background-position-x: -6px !important;
}
</style>
